export function vkFromEkSurcharge(ek: number, surchargePercent: number): number {
  if (!Number.isFinite(ek) || !Number.isFinite(surchargePercent)) return 0;
  return Math.round(ek * (1 + surchargePercent / 100) * 100) / 100;
}

/**
 * Aufschlag passend zu einem direkt eingegebenen Material-VK. Passt der VK schon zu EK und
 * Aufschlag, bleibt der Aufschlag stehen (kein Rundungsdrift 70 → 69,99); ohne EK ebenso.
 */
export function surchargeForVk(ek: number, surchargePercent: number, vk: number): number {
  if (!Number.isFinite(ek) || !Number.isFinite(vk) || ek <= 0.0001) return surchargePercent;
  if (Math.abs(ek * (1 + surchargePercent / 100) - vk) <= 0.006) return surchargePercent;
  return Math.round((vk / ek - 1) * 10_000) / 100;
}

export function marginPercent(unitCostEk: number, unitPriceVk: number): number | null {
  if (!Number.isFinite(unitCostEk) || !Number.isFinite(unitPriceVk) || unitPriceVk === 0) {
    return null;
  }
  return Math.round(((unitPriceVk - unitCostEk) / unitPriceVk) * 10_000) / 100;
}
